import styled from 'styled-components';
import { sizes } from 'style';
import { motion } from 'framer-motion6';
import { ReactComponent as FeatherImg } from 'products/global/assets/img/join-us/feather-white.svg';

const Feather = styled(FeatherImg)`
  position: absolute;
  display: none;

  @media ${sizes.tabletLandscape} {
    display: block;
  }
`;

export const MobileFeather = styled(FeatherImg)`
  position: absolute;
  display: block;

  @media ${sizes.tabletLandscape} {
    display: none;
  }
`;

export const TopLeftFeather = styled(motion(Feather))`
  top: 8px;
  left: 0px;

  @media ${sizes.extraLargeDesktop} {
    left: -30px;
  }
`;

export const TopRightFeather = styled(motion(Feather))`
  top: 20px;
  right: 55px;
  width: 162px;
  height: 315px;
`;

export const BottomRightFeather = styled(motion(Feather))`
  top: 84%;
  right: 55px;
  width: 98px;
  height: 190px;
  z-index: 2;

  @media ${sizes.desktop} {
    top: 80%;
    right: 64px;
  }
`;

export const MiddleFeather = styled(motion(Feather))`
  top: 8%;
  right: 45%;
  width: 48px;
  height: 93px;
`;

export const RightMiddleFeather = styled(motion(Feather))`
  top: 38%;
  right: 18%;
  width: 67px;
  height: 131px;
`;

export const MobileTopFeather = styled(motion(MobileFeather))`
  right: 40px;
  top: 0px;
  width: 50px;
  height: 95px;
`;
export const MobileBottomFeather = styled(motion(MobileFeather))`
  right: 52px;
  bottom: 32px;
  width: 78px;
  height: 151px;
`;
